module.exports = __webpack_public_path__ + "img/world-white.dd407deb.svg";